var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSign4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 173 167.9",
    style: {
      enableBackground: "new 0 0 173 167.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#04E6D4;stroke-width:2;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#04E6D4;stroke-width:2;stroke-miterlimit:10;stroke-dasharray:16.663,5.207;}\n\t.st2{fill:none;stroke:#04E6D4;stroke-width:2;stroke-miterlimit:10;stroke-dasharray:18.857,5.893;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M172.8,19.4c-2.4-1.6-4.9-3.1-7.4-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.8,12.6C114.3-10.3,57.5,2.3,24.8,43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.2,45c-1.7,2.3-3.4,4.6-5,7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.3,168.1c-1.4-2.5-2.7-5.1-3.9-7.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.1,155c-9.9-24.7-10.8-52.8-2-78.2C7.8,71.8,10,66.8,12.4,62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.8,59.4c1.4-2.5,2.9-5,4.4-7.4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSign4);
export default __webpack_public_path__ + "static/media/sign4.3d833e8bcffd9d6c4934896b4ec2a115.svg";
export { ForwardRef as ReactComponent };